import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BaseReadOnlyService } from '../../services/base-readonly.service';
import { Language } from './language.model';

@Injectable({
    providedIn: 'root'
})
export class LanguageService extends BaseReadOnlyService<Language> {

    constructor(protected http: HttpClient) {
        super(http, 'language');
    }
}
